import React, { useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { toast } from 'sonner';
import { Badge } from 'react-bootstrap';
import { dateTimeConverter } from '../../utils/dateTimeConverter';
import { encryptLocalStorage } from '../../utils/localStorage.utils';

const AdminProfile = () => {

    const [profileData, setProfileData] = useState({});

    async function getProfileData() {
        loadingShow()
        let resp = await getApi(urlApi.getMyProfile);
        loadingHide()
        if (resp.responseCode === 200) {
            encryptLocalStorage("profile", resp.data);
            setProfileData(resp.data)
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        getProfileData();
    }, []);

    return (
        <Layout>
            <div className='p-4 flex items-center'>
                <div className='flex items-center flex-col gap-2 shadow-lg px-32 py-8 rounded-xl w-max mx-auto'>
                    <img src={profileData?.profilePic} alt="" className='h-20 aspect-square rounded-full object-contain' />
                    <h1 className='uppercase font-bold text-2xl'>Welcome 👋</h1>
                    <p className='capitalize font-medium text-xl'>{profileData?.username}</p>
                    <div className='flex gap-2'>
                        <Badge bg={profileData?.status == 1 ? "success" : "warning"} >{profileData?.status == 1 ? "Active" : "InActive"}</Badge>
                        <Badge>{profileData?.adminType == 1 ? "Super Admin" : "Admin"}</Badge>
                    </div>
                    <p className='font-medium'>{profileData?.phone}</p>
                    <p className='text-sm'>Joined : {dateTimeConverter(profileData?.createdAt)}</p>
                </div>
            </div>
        </Layout>
    )
}

export default AdminProfile